<template>
  <div>
    <VueSlimTable
      ref="table"
      :source="getFBAccounts"
      :columns="columns"
      class="responsive-table borderless-table m-0">
      <template #row="{ row }">
        <TableRow :row="row" />
      </template>
    </VueSlimTable>
  </div>
</template>

<script>
import axios from 'axios'
import { subscribe, removeChannel } from 'vue_widgets/audit_report_configurations/helpers'
import TableRow from './table_row'

export default {
  components: { TableRow },
  props: {
    facebookAccountsPath: { type: String, required: true }
  },
  created() {
    this.columns = [
      { key: 'profileName', title: 'Profile Name' },
      { key: 'facebookPages', title: 'Facebook Pages' },
      { key: 'syncLastAt', title: 'Sync Last At' },
      { key: 'disconnectedAt', title: 'Disconnected At' },
      { key: 'actions', title: '' }
    ]

    this.channel = subscribe('AccountUpdateFbChannel', () => {
      this.getFBAccounts()
    })
  },
  beforeDestroy() {
    removeChannel(this.channel)
  },
  methods: {
    getFBAccounts() {
      return axios.get(this.facebookAccountsPath).then((res) => res.data)
    }
  }
}
</script>
